import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=06cafab9&scoped=true&"
import script from "./Forget.vue?vue&type=script&lang=ts&"
export * from "./Forget.vue?vue&type=script&lang=ts&"
import style0 from "./Forget.vue?vue&type=style&index=0&id=06cafab9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cafab9",
  null
  
)

export default component.exports